import React from 'react';

export default function Clock({ className, style, showSeconds = true }) {
  const [now, setNow] = React.useState(() => new Date());

  React.useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const timeStr = now.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    second: showSeconds ? '2-digit' : undefined
  });

  const weekdayStr = now.toLocaleDateString('ru-RU', { weekday: 'long' });
  const dayStr = now.toLocaleDateString('ru-RU', { day: '2-digit' });
  const monthStr = now.toLocaleDateString('ru-RU', { month: 'long' });

  return (
    <div
      className={className}
      style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', alignItems: 'baseline', gap: 10, ...style }}
      aria-label="Текущие дата и время"
    >
      <span style={{ fontWeight: 800, fontSize: '1.15em', lineHeight: 1, color: 'var(--clock-time-color, #eaf2f9)' }}>{timeStr}</span>
      <span style={{ opacity: 0.5, margin: '0 2px' }}>•</span>
      <span style={{ opacity: 0.95, fontSize: '0.95em', textTransform: 'capitalize', fontWeight: 700, color: 'var(--clock-weekday-color, #cbd5f5)' }}>
        {weekdayStr}
      </span>
      <span style={{ opacity: 0.7, margin: '0 4px' }}>•</span>
      <span style={{ opacity: 0.95, fontSize: '0.95em', textTransform: 'capitalize', fontWeight: 700, color: 'var(--clock-month-color, #eaf2f9)' }}>
        {dayStr} {monthStr}
      </span>
    </div>
  );
}


